import baseComponents from "styles/theme/base-components"

const components = {
  ...baseComponents,
}

components.checkout = {
  ...components.checkout,
  shipMethod: {
    ...components.checkout.shipMethod,
    checkboxWrapper: { pl: "12px" },
  },
}

export default components
